class LambdaCountdown
{

    SourceElement = null;
    Format = 'D:H:M:S';
    SourceDate = null;
    ParsedDate = null;
    TickInterval = null;
    TickCallback = null;
    CurrentCountdown = {
        Finished: false,
        Years: 0,
        Months: 0,
        Weeks: 0,
        Days: 0,
        Hours: 0,
        Minutes: 0,
        Seconds: 0
    };

    static fromElement(el)
    {
        var inst = new LambdaCountdown();
        inst.initElement(el);
        return inst;
    }

    initElement(el)
    {
        const targetDateStr = el.getAttribute('data-countdown-date');
        const format = el.getAttribute('data-countdown-format') || 'D:H:M:S';
        const targetDate = this.parseDate(targetDateStr);

        this.SourceElement = el;
        this.Format = format;
        this.SourceDate = targetDateStr;
        this.ParsedDate = targetDate;

        if(!targetDate) {
            console.error('Invalid date format for countdown:', targetDateStr, 'for element:', el);
            return;
        }

        this.onTick();

        this.TickInterval = setInterval(() => this.onTick(), 1000);

    }

    parseDate(dateStr)
    {
        return new Date(dateStr);
    }

    setFormat(format)
    {
        this.Format = format;
    }

    setDate(date)
    {
        this.SourceDate = date;
        this.ParsedDate = this.parseDate(date);
    }

    setTickCallback(callback)
    {
        if(typeof callback !== 'function') {
            console.error('Tick callback must be a function.');
            return;
        }
        this.TickCallback = callback;
    }

    start()
    {
        if(this.ParsedDate == null) {
            console.error('Countdown date is not set. Please set a valid date before starting the countdown.');
            return;
        }

        if(this.SourceElement != null) {
            console.error('Countdown is already initialized with an element. Please create a new instance for a different countdown.');
            return;
        }

        if(this.TickInterval != null) {
            console.warn('Countdown is already running.');
            return;
        }

        this.onTick();
        this.TickInterval = setInterval(() => this.onTick(), 1000);

    }

    stop()
    {
        if(this.TickInterval != null) {
            clearInterval(this.TickInterval);
            this.TickInterval = null;
        }
    }

    onTick()
    {
        const now = new Date();
        let diff = this.ParsedDate - now;

        if(diff <= 0) {
            this.CurrentCountdown.Finished = true;
            clearInterval(this.TickInterval);
            return;
        }

        const breakdown = this.breakdownDuration(diff, now);

        this.CurrentCountdown = breakdown;

        if(this.TickCallback != null) {
            this.TickCallback(this.CurrentCountdown);
        }

    }

    breakdownDuration(ms, now)
    {
        const target = this.ParsedDate;
        const units = this.Format.split(':');
        let remaining = ms;

        const out = {
            Finished: false,
            Years: 0,
            Months: 0,
            Weeks: 0,
            Days: 0,
            Hours: 0,
            Minutes: 0,
            Seconds: 0
        };

        const dtStart = new Date(now);
        let dtTemp = new Date(dtStart);
        let Yr = 0, Mo = 0;

        if(units.includes('Y'))
        {
            while(new Date(dtTemp.getFullYear() + 1, dtTemp.getMonth(), dtTemp.getDate()) <= target)
            {
                dtTemp.setFullYear(dtTemp.getFullYear() + 1);
                Yr++;
            }

            out.Years = Yr;
        }

        if(units.includes('MO'))
        {
            while (new Date(dtTemp.getFullYear(), dtTemp.getMonth() + 1, dtTemp.getDate()) <= target)
            {
                dtTemp.setMonth(dtTemp.getMonth() + 1);
                Mo++;
            }

            out.Months = Mo;
        }

        const remainingMs = target - dtTemp;

        let Secs  = Math.floor(remainingMs / 1000) % 60;
        let Mins  = Math.floor(remainingMs / 1000 / 60) % 60;
        let Hrs   = Math.floor(remainingMs / 1000 / 60 / 60) % 24;
        let Days  = Math.floor(remainingMs / 1000 / 60 / 60 / 24);
        let Weeks   = 0;

        if(units.includes('W')) {
            Weeks = Math.floor(Days / 7);
            Days = Days % 7;
        }

        out.Weeks       = Weeks;
        out.Days        = Days;
        out.Hours       = Hrs;
        out.Minutes     = Mins;
        out.Seconds     = Secs;

        return out;

    }

    getParsedFormat()
    {
        return this.Format.split(':');
    }

    hasYears()
    {
        return this.getParsedFormat().includes('Y');


    }

    hasMonths()
    {
        return this.getParsedFormat().includes('MO');


    }

    hasWeeks()
    {
        return this.getParsedFormat().includes('W');


    }

    hasDays()
    {
        return this.getParsedFormat().includes("D");
    }

    hasHours()
    {
        return this.getParsedFormat().includes("H");
    }

    hasMinutes()
    {
        return true;
    }

    hasSeconds()
    {
        return true;
    }

}

export default LambdaCountdown;
